import React, { FC } from 'react'
import { G, Path, Svg, SvgProps } from 'react-native-svg'

const StarsIcon: FC<SvgProps> = ({ width, height, color = '#ffa000', style }) => {
  return (
    <Svg width={width} height={height} style={style} viewBox="0 0 12 12">
      <G>
        <Path fill="none" d="M12 11.999H.001V0H12z" />
        <G fill={color}>
          <Path d="M7.438.18a.238.238 0 0 1 .461 0l.92 3.977a.232.232 0 0 0 .122.154l2.93 1.483a.229.229 0 0 1 0 .41l-2.93 1.484a.232.232 0 0 0-.122.154l-.92 3.977a.238.238 0 0 1-.461 0l-.92-3.977a.232.232 0 0 0-.122-.154L3.464 6.204a.229.229 0 0 1 0-.41l2.93-1.483a.232.232 0 0 0 .122-.154Z" />
          <Path d="M1.521.175a.238.238 0 0 1 .458 0l.288 1.119a.232.232 0 0 0 .116.147l.994.528a.229.229 0 0 1 0 .406l-.994.525a.232.232 0 0 0-.116.147l-.288 1.122a.238.238 0 0 1-.458 0L1.233 3.05a.232.232 0 0 0-.116-.15l-.994-.528a.229.229 0 0 1 0-.406l.994-.526a.232.232 0 0 0 .116-.147Z" />
          <Path d="M3.19 7.906a.154.154 0 0 1 .3 0l.292 1.239a.15.15 0 0 0 .077.1l.989.517a.148.148 0 0 1 0 .264l-.989.519a.15.15 0 0 0-.077.1l-.293 1.239a.154.154 0 0 1-.3 0l-.292-1.239a.15.15 0 0 0-.077-.1l-.991-.518a.148.148 0 0 1 0-.264l.991-.518a.15.15 0 0 0 .077-.1Z" />
        </G>
      </G>
    </Svg>
  )
}

export default StarsIcon
